/**
 * State configuration for the shared NAPLAN preparation template.
 * Only state-specific values live here; prices come from course_pricing and
 * centres from schoolola_centers at runtime.
 */
export type NaplanStateCode = 'NSW' | 'VIC' | 'WA';

export interface NaplanStateConfig {
  code: NaplanStateCode;
  name: string;
  shortName: string;
  path: string;
  department: string;
}

export const NAPLAN_STATES: Record<NaplanStateCode, NaplanStateConfig> = {
  NSW: { code: 'NSW', name: 'New South Wales', shortName: 'NSW', path: '/programs/nsw/naplan-preparation', department: 'NSW Department of Education' },
  VIC: { code: 'VIC', name: 'Victoria', shortName: 'VIC', path: '/programs/vic/naplan-preparation', department: 'Victorian Department of Education' },
  WA: { code: 'WA', name: 'Western Australia', shortName: 'WA', path: '/programs/wa/naplan-preparation', department: 'WA Department of Education' },
};

export const SHARED_NAPLAN_PATH = '/programs/naplan-preparation';

export const isNaplanState = (state: string | null | undefined): state is NaplanStateCode =>
  state === 'NSW' || state === 'VIC' || state === 'WA';

/** NAPLAN link for the selected state; states without a NAPLAN template use the shared page. */
export const getNaplanHref = (state: string | null | undefined): string =>
  isNaplanState(state) ? NAPLAN_STATES[state].path : SHARED_NAPLAN_PATH;
